<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-4': $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                    <router-link to="/employee_study">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{ $t("Статистика") }}
                        </v-breadcrumbs-item>
                    </router-link>
                    <router-link v-if="$route.query.directorate && saved_department.text" :to="directorate_path">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{ saved_department.text }}
                        </v-breadcrumbs-item>
                    </router-link>
                    <router-link v-if="$route.query.organization && saved_company.text" :to="org_path">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> <span v-html="saved_company.text"></span>
                        </v-breadcrumbs-item>
                    </router-link>
                    <!-- <div>
                        <v-breadcrumbs-item :disabled="true">
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon> {{ other_user.family + ' ' + other_user.name + ' ' + other_user.patronymic }}
                        </v-breadcrumbs-item>
                    </div> -->
                </v-breadcrumbs>
                <div>
                    <v-layout row align-center :class="{'mx-3': $vuetify.breakpoint.xs}">
                        <img v-if="$vuetify.breakpoint.smAndUp" :src="other_user.avatar" alt=""
                             width="70" height="70"
                        >
                        <h1 class="display-1 my-4 font-weight-regular" :class="{'ml-4': $vuetify.breakpoint.smAndUp}">{{ other_user.family + ' ' + other_user.name + ' ' + other_user.patronymic }}</h1>
                    </v-layout>
                    <v-layout row wrap class="grey-text"
                              :class="{'mt-2': $vuetify.breakpoint.lgAndUp, 'mx-3': $vuetify.breakpoint.xs}"
                    >
                        <iconLabel icon_name="job" class="pr-3 flex md2 sm4 mt-2" size="20">{{ other_user.position }}</iconLabel>
                    </v-layout>
                    <v-layout class="wrap border-bottom" :class="{'mx-3 py-3': $vuetify.breakpoint.xs,'py-5': $vuetify.breakpoint.smAndUp}">
                        <v-flex md2 sm3 xs12
                                :class="{'mb-4': $vuetify.breakpoint.xs}"
                        >
                            <v-layout column>
                                <v-flex class="mb-1">{{ $t("Организация") }}</v-flex>
                                <router-link :to="{name: 'company_other', params: {id: other_user.company_id}}" class="link link--green">
                                    {{ other_user.company_name }}
                                </router-link>
                            </v-layout>
                        </v-flex>
                        <v-flex md2 sm4 :class="{'ml-3': $vuetify.breakpoint.smAndUp}">
                            <v-layout align-center :class="{'wrap justify-center': $vuetify.breakpoint.xs}">
                                <div class="profile__stat border-red"
                                     :class="{'ml-0 mb-2': $vuetify.breakpoint.mdAndDown,'mr-3': $vuetify.breakpoint.mdAndUp}"
                                >{{ user_in_company_rating.rating }}</div>
                                <v-flex class="md8 profile__stat-text ml-2 red-text"
                                        :class="{'text-xs-center' : $vuetify.breakpoint.xs}"
                                >{{ $t("Рейтинг в своей организации") }}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex md2 sm4 :class="{'ml-3': $vuetify.breakpoint.smAndUp}">
                            <v-layout align-center :class="{'wrap justify-center': $vuetify.breakpoint.smAndDown}">
                                <div class="profile__stat border-grey"
                                     :class="{'ml-0 mb-2': $vuetify.breakpoint.mdAndDown,'mr-3': $vuetify.breakpoint.mdAndUp}"
                                >{{ user_rating.rating }}</div>
                                <v-flex class="md8 profile__stat-text ml-2"
                                        :class="{'text-xs-center' : $vuetify.breakpoint.xs}"
                                >{{ $t("Общий рейтинг") }}</v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap align-end
                              justify-space-between :class="{'mx-3 my-3': $vuetify.breakpoint.xs, 'my-5': $vuetify.breakpoint.smAndUp}"
                    >
                        <v-flex md5 sm7 xs12
                                :class="{'mb-4': $vuetify.breakpoint.smAndDown,'mr-4 mb-0': $vuetify.breakpoint.smAndUp}"
                        >
                            <inputIcon v-model="search_table" class="layout row search--no-border" icon_name="search"
                                       :placeholder="$t('Поиск по разделу')"
                            />
                        </v-flex>
                        <a :href="String(url + export_url.url)" target="_blank">
                            <buttonRed class="flex md3 sm5 xs12" :class="{'my-3': $vuetify.breakpoint.xs}">{{ $t("Экспорт данных") }}</buttonRed>
                        </a>
                        <buttonBdWhite class="flex md3 sm5 xs12" @click.native="toggle_filter()">{{ showed_filter ? $t('Скрыть фильтр') : $t('Показать фильтр') }}</buttonBdWhite>
                    </v-layout>
                    <v-layout v-if="showed_filter" class="wrap align-end justify-space-between" :class="{'mx-3 mb-3': $vuetify.breakpoint.xs, 'mb-5': $vuetify.breakpoint.smAndUp}">
                        <v-flex lg4 md3 sm5
                                xs12 class="mb-4"
                        >
                            <v-layout column>
                                <div class="text-uppercase mb-3"> {{ $t("Статус") }}</div>
                                <v-select
                                    :items="total_stats.filter_statuses"
                                    solo
                                    append-icon=""
                                    :label="$t('Все')"
                                    class="input"
                                    :value="filter_values.status"
                                    @change="get_status($event)"
                                >
                                  <template #append>
                                    <v-icon aria-hidden="true" translate="no">
                                      expand_more
                                    </v-icon>
                                  </template>
                                </v-select>
                            </v-layout>
                        </v-flex>
                        <!-- <v-flex lg3 md3 sm5
                                xs12 class="align-self-center" :class="{'mb-4': $vuetify.breakpoint.xs, 'pl-4': $vuetify.breakpoint.mdAndUp}"
                        >
                            <checkbox id="required_courses" :checked="filter_values.course_required" @change="get_course_required($event)">{{$t("Обязательные курсы")}}</checkbox>
                        </v-flex> -->
                        <v-flex lg5 md6 sm12
                                xs12 class="mb-4"
                        >
                            <div class="text-uppercase mb-3">{{ $t("Дата/Период") }}</div>
                            <v-layout row wrap justify-space-between>
                                <datepicker ref="datafilter_from" :class="{'mb-3': $vuetify.breakpoint.xs, 'mr-3': $vuetify.breakpoint.sm }" class="flex md6 sm5 xs12"
                                            placeholder="01-01-2018"
                                            :value="filter_values.period_start" @change="get_period_start($event)"
                                />
                                <datepicker ref="datafilter_to" class="flex xs12 sm5 md6" :value="filter_values.period_finish"
                                            placeholder="01-01-2018"
                                            @change="get_period_finish($event)"
                                />
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 class="mb-4">
                            <v-layout wrap align-center justify-end>
                                <redLink class="pr-3" :class="{'flex xs12 mb-4': $vuetify.breakpoint.xs}" @click.prevent="reset_filter">{{ $t("Сбросить фильтр") }}</redLink>
                                <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="accept_filter()">{{ $t("Применить") }}</buttonRed>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout align-start wrap class="mb-4">
                        <v-flex xs12 :class="{'order-md1': $vuetify.breakpoint.mdAndUp}">
                            <dataTable :table="employee_study_courses" type="courses" />
                            <dataTablePagination :table="employee_study_courses" />
                        </v-flex>
                    </v-layout>
                    <v-dialog :value="employee_study_modal.active" persistent content-class="scrolled-dialog">
                        <employeeStudyModal v-if="employee_study_modal.active" />
                    </v-dialog>
                    <v-dialog :value="course_stat_modal.active" persistent content-class="scrolled-dialog">
                        <courseStatModal v-if="course_stat_modal.active" />
                    </v-dialog>
                </div>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import buttonRed   from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import baseInput from '@/components/ui/inputs/base/input.vue';
import checkbox from '@/components/ui/inputs/base/checkbox.vue';
import datepicker from '@/components/ui/inputs/base/datepicker.vue';
import redLink from '@/components/ui/links/styled/link_red';
import greenLink from '@/components/ui/links/styled/link_green';
import iconLabel   from '@/components/ui/icons/icon_with_label.vue';
import employeeStudyModal from '../Employee_study_modals/Employee_study_modal';
import courseStatModal from '../Employee_study_modals/Course_stat_modal';
import dataTable from '../Employee_study_table';
import dataTablePagination from '../Employee_study_pagination';

import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    inputIcon,
    buttonRed,
    buttonBdWhite,
    datepicker,
    redLink,
    iconLabel,
    employeeStudyModal,
    courseStatModal,
    dataTable,
    dataTablePagination,
  },
  data() {
    return {
      value: [],
      user : {
        role : 'manager',
        roles: ['admin', 'manager'],
      },
      filter_values: {
        status         : '',
        course_required: false,
        period_start   : '',
        period_finish  : '',
        search         : '',
      },
      request: {
        user_type      : [],
        company_group  : [],
        company        : 0,
        region         : 0,
        city           : 0,
        department     : 0,
        course         : 0,
        course_required: '',
        role           : 0,
        specialization : 0,
        period_start   : '',
        period_finish  : '',
        search         : '',
        user_id        : '',
        status         : 0,
      },
      saved_department: {},
      saved_company   : {},
      saved_user      : 0,

    };
  },
  computed: {
    ...mapState('common', ['url']),
    ...mapState('employee_study', ['search']),
    directorate_path() {
      if (this.$route.params.directorate) {
        return '/employee_study/' + this.$route.params.directorate;
      } else {
        return '/employee_study';
      }
    },
    org_path() {
      if (this.$route.params.organization_name && this.$route.params.directorate) {
        return '/employee_study/'+this.$route.params.directorate+'/'+this.$route.params.organization;
      } else {
        return '/employee_study/'+this.$route.params.organization;
      }
    },
    showed_filter() {
      return this.showed_courses_filter;
    },
    search_table: {
      get() {
        return this.search;
      },
      set($event) {
        let value = $event.target ? $event.target.value : $event;
        this.request.search = value;
        this.SET_SEARCH_GENERAL(value);
        return this.get_learning_stats({'filter': this.request, 'level': 'courses'});
      },
    },
    ...mapGetters('profile/other_user', [
      'other_user',
    ]),
    ...mapGetters('employee_study/directorate', [
      'get_directorate_by_id',
      'example_directorate',
    ]),
    ...mapGetters('employee_study/organizations', [
      'get_organization_by_id',
      'example_organization',
    ]),
    ...mapGetters('employee_study/users', [
      'get_user_by_id',
      'example_user',
    ]),
    ...mapGetters('employee_study/courses', [
      'employee_study_courses',
      'showed_courses_filter',
    ]),
    ...mapGetters('employee_study', [
      'employee_study_modal',
      'course_stat_modal',
      'tab',
      'total_stats',
      'export_url',
      'current_department',
      'current_company',
      'current_user',
    ]),
    ...mapGetters('rating', [
      'user_rating',
      'user_in_company_rating',
    ]),
  },
  async mounted() {
    this.saved_department = localStorage.current_department ? JSON.parse(localStorage.getItem('current_department')) : {};
    this.saved_company = localStorage.current_company ? JSON.parse(localStorage.getItem('current_company')) : {};
    this.saved_user = localStorage.current_user ? JSON.parse(localStorage.getItem('current_user')) : 0;

    await this.get_other_user(this.saved_user);
    await this.get_user_rating(this.saved_user);
    await this.get_user_in_company_rating(this.saved_user);
    await this.accept_filter();
  },
  methods: {
    ...mapMutations('employee_study', [
      'SET_ACTIVE_TAB',
      'SET_SEARCH_GENERAL',
    ]),
    ...mapActions('employee_study', [
      'get_learning_stats',
    ]),
    ...mapMutations('employee_study/courses', [
      'TOGGLE_COURSES_FILTER',
      'SEARCH_COURSES',
    ]),
    ...mapActions('employee_study/courses', [
      'get_courses',
    ]),
    ...mapActions('profile/other_user', [
      'get_other_user',
    ]),
    ...mapActions('rating', [
      'get_user_rating',
      'get_user_in_company_rating',
    ]),
    toggle_filter() {
      this.TOGGLE_COURSES_FILTER(event);
    },
    percent(total, value) {
      if (value<total) {
        return Math.round((value/total)*100);
      } else return 100;
    },
    get_status(event) {
      let status = this.total_stats.filter_statuses.find((item)=>item.text==event);
      if (status) {
        this.request.status = status.id;
        this.filter_values.status = event;
      }
    },
    get_course_required(event) {
      if (event.target && event.target.checked || event===true) {
        this.request.course_required = 'Y';
        this.filter_values.course_required = true;
      } else {
        this.request.course_required = '';
        this.filter_values.course_required = false;
      }
    },
    get_period_start(event) {
      this.request.period_start = event.target.value.split(' ')[0];
      this.filter_values.period_start = event.target.value;
    },
    get_period_finish(event) {
      this.request.period_finish = event.target.value.split(' ')[0];
      this.filter_values.period_finish = event.target.value;
    },
    async accept_filter() {
      await this.get_learning_stats({'filter': Object.assign(this.request, {tab: 'courses'}), 'level': 'courses'});
    },
    reset_object(object) {
      for (let [key, value] of Object.entries(object)) {
        switch (Object.prototype.toString.call(value)) {
          case '[object String]':
            object[key] = '';
            break;
          case '[object Number]':
            object[key] = 0;
            break;
          case '[object Boolean]':
            object[key] = false;
            break;
          case '[object Array]':
            object[key] = [];
            break;
          default:
            object[key] = undefined;
        }
      }
    },
    reset_filter() {
      this.SET_SEARCH_GENERAL('');

      this.reset_object(this.request);
      this.reset_object(this.filter_values);

      this.$refs.datafilter_from.clear_calendar();
      this.$refs.datafilter_to.clear_calendar();

      this.accept_filter();
    },
  },
};
</script>
